exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!animate.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nhtml, body {\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  background-image: url(" + require("./assets/home.jpg") + ");\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/Jose.Soto/Documents/Websites/SecretSanta/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/Jose.Soto/Documents/Websites/SecretSanta/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles